// extracted by mini-css-extract-plugin
module.exports = {"root":"SubTab_root__1b1n5","isActive":"SubTab_isActive__2cXYQ","disabled":"SubTab_disabled__ISPKR"};